import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Crown, CheckCircle2, Loader2, ArrowRight, AlertTriangle } from "lucide-react";
import { ACADEMY_LOGO_H } from "../data/assets";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GOLD = "#D4AF37";

// One-tap "Renew In Person" landing from the VIP expiry email: fires the request on load.
export default function Renew() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    axios.post(`${API}/vip/renew/${token}`).then(({ data }) => setState({ loading: false, ...data })).catch((e) => setState({ loading: false, error: e?.response?.data?.detail || "This renew link is no longer valid." }));
  }, [token]);
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-5 elite-carbon-bg grain">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} data-testid="renew-card"
        className="relative w-full max-w-md rounded-2xl border p-7 sm:p-9" style={{ borderColor: `${GOLD}55`, background: "linear-gradient(160deg, rgba(212,175,55,0.08), rgba(10,10,10,0.92))", boxShadow: `0 0 60px ${GOLD}22` }}>
        <img src={ACADEMY_LOGO_H} alt="The Next O Technical Academy" className="h-12 w-auto object-contain mb-6" />
        {state.loading ? (
          <div data-testid="renew-loading" className="flex items-center gap-3 text-white/70 text-sm"><Loader2 size={18} className="animate-spin" style={{ color: GOLD }} /> Sending your renew request to Coach Barker…</div>
        ) : state.error ? (
          <div data-testid="renew-error">
            <div className="flex items-center gap-2 mb-2 text-[#C41E24]"><AlertTriangle size={16} /><span className="text-[10px] font-bold uppercase tracking-widest">Link expired</span></div>
            <h1 className="font-headings text-3xl uppercase tracking-wide mb-3">We couldn't find that renew link</h1>
            <p className="text-sm text-white/60 mb-6">{state.error} You can still keep Elite access going online.</p>
          </div>
        ) : (
          <div data-testid="renew-success">
            <div className="flex items-center gap-2 mb-2" style={{ color: GOLD }}><CheckCircle2 size={16} /><span className="text-[10px] font-bold uppercase tracking-widest">{state.already_requested ? "Already on Coach Barker's list" : "Request received"}</span></div>
            <h1 className="font-headings text-3xl sm:text-4xl uppercase tracking-wide mb-3">{state.name}'s next {state.package}</h1>
            <p className="text-sm text-white/65 leading-relaxed mb-6">
              {state.already_requested
                ? <>Coach Barker already has your renew request from this week — he'll confirm the next package with you at training.</>
                : <>Done in one tap. <b className="text-white">Coach Barker has been notified</b> and will reach out to lock in {state.name}'s next in-person package (cash, Venmo or Zelle at training). Elite Hub access extends the moment it's logged.</>}
            </p>
          </div>
        )}
        {!state.loading && (
          <div className="space-y-2">
            <button data-testid="renew-go-elite" onClick={() => navigate("/subscribe?tier=elite")} className="w-full inline-flex items-center justify-center gap-2 bg-[#C41E24] hover:bg-[#A0161D] text-white text-xs font-bold uppercase tracking-wider py-3.5 rounded-sm transition-colors">
              <Crown size={14} /> Go Elite Online instead <ArrowRight size={14} />
            </button>
            <button data-testid="renew-back-hub" onClick={() => navigate("/hub")} className="w-full text-[11px] font-bold uppercase tracking-wider text-white/45 hover:text-white py-2">Back to the Hub</button>
          </div>
        )}
      </motion.div>
    </div>
  );
}
